import { atom, useAtomValue } from 'jotai';

import { currentTrackAtom } from '@/features/AudioPlayer/atoms';

const isPlayerActiveAtom = atom((get) => {
  const currentTrack = get(currentTrackAtom);
  return Boolean(currentTrack);
});

isPlayerActiveAtom.debugLabel = 'isPlayerActiveAtom';

export const useAnyPlayerActive = (): boolean =>
  useAtomValue(isPlayerActiveAtom);
